import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] text-primary-600">
            <span className="inline-block h-px w-6 bg-primary-400"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
      </div>
      {(actionLabel && actionTo) || children ? (
        <div className="flex shrink-0 items-center gap-3">
          {children}
          {actionLabel && actionTo && (
            <Link
              to={actionTo}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              {actionLabel}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>
      ) : null}
    </div>
  );
}